import clsx from 'clsx';
import styles from './Stat.module.css';

interface Props {
  label: string;
  value: string | number;
  hint?: string;
  variant?: 'default' | 'accent';
  size?: 'sm' | 'md';
}

export const Stat = ({ label, value, hint, variant = 'default', size = 'md' }: Props) => (
  <div className={clsx(styles.stat, styles[`size-${size}`], variant === 'accent' && styles.accent)}>
    <p className={styles.label}>{label}</p>
    <p className={styles.value}>{value}</p>
    {hint && <p className={styles.hint}>{hint}</p>}
  </div>
);